import { useEffect, useState } from "react";
import ContainerBox from "../../plugins/components/container";
import { useAxios } from "../../utils/useAxios";

export default function CarrierUser() {
  const [carriers, setCarriers] = useState([]);
  const [selectedCarrier, setSelectedCarrier] = useState<number | null>(null);
  const [availableUsers, setAvailableUsers] = useState<any[]>([]); // All users
  const [assignedUsers, setAssignedUsers] = useState<any[]>([]); // Users already assigned

  const [selectedAvailable, setSelectedAvailable] = useState<string[]>([]);
  const [selectedAssigned, setSelectedAssigned] = useState<string[]>([]);

  const { res: getCarrierList, mutate: GetCarrierListMutate } = useAxios({
    url: "/api/auth/carrier_user",
  });

  useEffect(() => {
    GetCarrierListMutate(
      { getCarrierList: true },
      {
        onSuccess: (res: any) => {
          setCarriers(res?.data?.data || []);
        },
      },
    );
  }, []);

  const { res: getCarrierRes, mutate: formMutate } = useAxios({
    url: "/api/auth/carrier_user",
  });

  useEffect(() => {
    // Fetch user list
    formMutate(
      { getUserList: true },
      {
        onSuccess: (res: any) => {
          setAvailableUsers(res?.data?.data || []);
        },
      },
    );
  }, []);

  const handleCarrierChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const id = Number(e.target.value);
    setSelectedCarrier(id);

    if (!id) return;

    formMutate(
      { carrier_id: id, getCarrierUser: true },
      {
        onSuccess: (res: any) => {
          const users = res.data?.data || [];
          setAssignedUsers(users); // Assigned users
        },
      },
    );
  };

  const moveToAssigned = () => {
    const toAssign = availableUsers.filter((u) =>
      selectedAvailable.includes(String(u.id)),
    );

    const newAssigned = [
      ...assignedUsers,
      ...toAssign.filter((u) => !assignedUsers.some((a) => a.id === u.id)),
    ];

    setAssignedUsers(newAssigned);
    setSelectedAvailable([]);
  };

  const moveToAvailable = () => {
    const newAssigned = assignedUsers.filter(
      (u) => !selectedAssigned.includes(String(u.id)),
    );
    setAssignedUsers(newAssigned);
    setSelectedAssigned([]);
  };

  const handleSave = () => {
    if (!selectedCarrier) return;

    formMutate(
      {
        assignUsers: true,
        carrier_id: selectedCarrier,
        user_id: assignedUsers.map((u) => u.id),
      },
      {
        onSuccess: () => {
          alert("Users assigned successfully!");
        },
      },
    );
  };

  const availableOptions = availableUsers.filter(
    (u) => !assignedUsers.some((a) => a.id === u.id),
  );

  return (
    <ContainerBox title={"Carrier User"} actions={""}>
      <div>
        <label className="block mb-1 font-semibold">Select Carrier</label>
        <select
          onChange={handleCarrierChange}
          className="h-9 w-full border px-4 py-1 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10"
        >
          <option value="">-- Select Carrier --</option>
          {carriers.map((carrier: any) => (
            <option key={carrier.id} value={carrier.id}>
              {carrier.name}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center justify-center border-gray-300 gap-6 p-6">
        {/* Available Users */}
        <div>
          <h3 className="font-bold mb-2">Available Users</h3>
          <select
            multiple
            value={selectedAvailable}
            onChange={(e) =>
              setSelectedAvailable(
                Array.from(e.target.selectedOptions, (option) => option.value),
              )
            }
            className="w-48 h-40 border border-gray-300 rounded p-2"
          >
            {availableOptions.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        {/* Buttons */}
        <div className="flex flex-col gap-2">
          <button
            onClick={moveToAssigned}
            className="bg-blue-500 text-white px-4 py-1 rounded"
          >
            &gt;&gt;
          </button>
          <button
            onClick={moveToAvailable}
            className="bg-red-500 text-white px-4 py-1 rounded"
          >
            &lt;&lt;
          </button>
        </div>

        {/* Assigned Users */}
        <div>
          <h3 className="font-bold mb-2">Assigned Users</h3>
          <select
            multiple
            value={selectedAssigned}
            onChange={(e) =>
              setSelectedAssigned(
                Array.from(e.target.selectedOptions, (option) => option.value),
              )
            }
            className="w-48 h-40 border border-gray-300 rounded p-2"
          >
            {assignedUsers.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <button
        onClick={handleSave}
        className="bg-green-600 text-white px-4 py-2 rounded mt-4"
      >
        Save Assignments
      </button>
    </ContainerBox>
  );
}
